import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import * as classnames from 'classnames';
import uuidv1 from 'uuid/v1';
import { GLOBAL } from '../../utils/Constants';

class InputAppend extends Component {
  constructor(props) {
    const { options, value: inputValue, selectValue } = props;
    super(props);
    const ops = options.filter(({ value }) => value === selectValue);
    this.state = {
      open: false,
      inputValue,
      appendValue: ops.length ? ops[0].value : '',
      appendText: ops.length ? ops[0].text : '',
    };
  }

  action = (inputValue, appendValue, appendText) => {
    const { handleChange } = this.props;
    this.setState({
      appendValue,
      appendText,
      inputValue,
      open: false
    });
    return handleChange && handleChange(inputValue, appendValue, appendText);
  };

  mouseLeave = () => {
    this.setState({ open: false });
  };

  renderMenu = () => {
    const { open, inputValue, appendText } = this.state;
    const { options } = this.props;
    const href = '#';
    const menuClasses = classnames('dropdown-menu', {
      show: open
    });
    return (
      <Fragment>
        <button
          className="btn btn-outline-secondary dropdown-toggle"
          type="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded={open}
          onClick={() => {
            this.setState({ open: !open });
          }}
        >
          {appendText}
        </button>
        <div className={menuClasses}>
          {options.map(({ text, value }) => (
            <a key={uuidv1()} className="dropdown-item" href={href} onClick={() => { this.action(inputValue, value, text); }}>
              {text}
            </a>
          ))}
        </div>
      </Fragment>
    );
  };

  render() {
    const { inputValue, appendValue, appendText } = this.state;
    const { showSelect, showValue, type, step, name, placeholder, options, handleBlur } = this.props;
    const leftSelect = showSelect === GLOBAL.LEFT;
    const leftValue = [GLOBAL.LEFT, 'both'].includes(showValue);
    const rightSelect = showSelect === GLOBAL.RIGHT;
    const rightValue = [GLOBAL.RIGHT, 'both'].includes(showValue);

    return options.length ? (
      <div className="input-append input-group" onMouseLeave={this.mouseLeave}>
        {leftSelect || leftValue ? (
          <div className="input-group-prepend">
            {leftSelect ? this.renderMenu() : null}
            {leftValue && appendValue ? (<span className="input-group-text">{appendValue}</span>) : null}
          </div>
        ) : null}
        <input
          type={type}
          name={name}
          placeholder={placeholder}
          value={inputValue}
          onChange={({ target: { value } }) => { this.action(value, appendValue, appendText); }}
          className="form-control"
          step={step}
          onBlur={handleBlur}
        />
        {rightSelect || rightValue ? (
          <div className="input-group-append">
            {rightValue && appendValue ? (<span className="input-group-text">{appendValue}</span>) : null}
            {rightSelect ? this.renderMenu() : null}
          </div>
        ) : null}
      </div>
    ) : null;
  }
}

InputAppend.defaultProps = {
  type: 'text',
  showSelect: GLOBAL.RIGHT,
  showValue: GLOBAL.RIGHT
};

InputAppend.propTypes = {
  showSelect: PropTypes.oneOf([
    GLOBAL.LEFT,
    GLOBAL.RIGHT
  ]),
  showValue: PropTypes.oneOf([
    GLOBAL.LEFT,
    GLOBAL.RIGHT,
    'both'
  ]),
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  type: PropTypes.string,
  step: PropTypes.oneOfType([
    PropTypes.number.isRequired,
    PropTypes.string.isRequired,
  ]),
  value: PropTypes.oneOfType([
    PropTypes.number.isRequired,
    PropTypes.string.isRequired,
  ]),
  selectValue: PropTypes.oneOfType([
    PropTypes.number.isRequired,
    PropTypes.string.isRequired,
  ]),
  options: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    value: PropTypes.string,
  })).isRequired,
  handleChange: PropTypes.func,
};


export default InputAppend;
